import script from "./classList.vue?vue&type=script&setup=true&lang=js"
export * from "./classList.vue?vue&type=script&setup=true&lang=js"

import "./classList.vue?vue&type=style&index=0&id=5b4b3430&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4b3430"]])

export default __exports__